// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
body {
  margin: 0;
  font-family: 'Arial', sans-serif;
  background-color: #f5f5f5;
  color: #333;
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Dark Mode Styles */
body.dark-mode {
  background-color: #121212;
  color: #f5f5f5;
}

.dark-mode .App {
  background-color: #121212;
}

.dark-mode .paper-item,
.dark-mode .message,
.dark-mode .filters select,
.dark-mode .filters input,
.dark-mode .chat-sidebar input {
  background-color: #1e1e1e;
  color: #f5f5f5;
  border-color: #333;
}

.dark-mode .paper-item:hover {
  box-shadow: 0 4px 8px rgba(255, 255, 255, 0.1);
}

.dark-mode .viewer-navbar,
.dark-mode .chat-sidebar {
  background-color: #1e1e1e;
  border-color: #333;
}

.dark-mode .message.assistant {
  background-color: #2d2d2d;
  color: #f5f5f5;
  border-color: #444;
}

.dark-mode .site-header.scrolled::before {
  background: rgba(0, 0, 0, 0.95);
}

.App {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* Home Screen */
.home-screen {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.filters {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filters select,
.filters input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  background-color: #fff;
}

.filters button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.filters button:hover {
  background-color: #0056b3;
}

.paper-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.paper-item {
  padding: 15px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.paper-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Updated viewer layout */
.viewer-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.viewer-navbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #f8f9fa;
  padding: 10px;
  border-bottom: 1px solid #ddd;
  display: flex;
  gap: 10px;
  align-items: center;
}

.viewer-body {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

.pdf-viewer {
  flex: 1 1;
  padding: 20px;
  overflow-y: auto;
}

/* Updated Chat Sidebar */
.chat-sidebar {
  width: 300px;
  height: 100%;
  background-color: #f8f9fa;
  border-left: 1px solid #ddd;
  display: flex;
  flex-direction: column;
}

.chat-messages {
  flex: 1 1;
  padding: 10px;
  overflow-y: auto;
}

.message {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 5px;
  background-color: #fff;
  border: 1px solid #ddd;
}

.message.user {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
  align-self: flex-end;
}

.message.assistant {
  background-color: #f1f1f1;
  color: #333;
  border-color: #ddd;
  align-self: flex-start;
}

.chat-sidebar form {
  display: flex;
  gap: 10px;
  padding: 10px;
  border-top: 1px solid #ddd;
}

.chat-sidebar input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.chat-sidebar button {
  padding: 10px 15px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.chat-sidebar button:hover {
  background-color: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .filters {
    flex-direction: column;
  }

  .viewer-container {
    flex-direction: column;
  }

  .chat-sidebar {
    width: 100%;
    height: 300px;
    border-left: none;
    border-top: 1px solid #ddd;
  }
}

/* Paper note styles */
.paper-note-blue {
  display: inline-block;
  background-color: blue;
  color: white;
  padding: 2px 4px;
  border-radius: 3px;
  margin-right: 5px;
  font-size: 14px;
}

.paper-note-green {
  display: inline-block;
  background-color: green;
  color: white;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 14px;
}

/* Remove default bottom margin from react-pdf pages to eliminate blank space between each PDF page */
.react-pdf__Page {
  margin-bottom: 0 !important;
}

/* Additional fix: force the canvas element rendered by react-pdf to display as block to remove extra whitespace */
.react-pdf__Page canvas {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;EACX,uDAAuD;AACzD;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qGAAqG;AACrG;EACE,2BAA2B;AAC7B;;AAEA,kHAAkH;AAClH;EACE,cAAc;AAChB","sourcesContent":["/* General Styles */\nbody {\n  margin: 0;\n  font-family: 'Arial', sans-serif;\n  background-color: #f5f5f5;\n  color: #333;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Dark Mode Styles */\nbody.dark-mode {\n  background-color: #121212;\n  color: #f5f5f5;\n}\n\n.dark-mode .App {\n  background-color: #121212;\n}\n\n.dark-mode .paper-item,\n.dark-mode .message,\n.dark-mode .filters select,\n.dark-mode .filters input,\n.dark-mode .chat-sidebar input {\n  background-color: #1e1e1e;\n  color: #f5f5f5;\n  border-color: #333;\n}\n\n.dark-mode .paper-item:hover {\n  box-shadow: 0 4px 8px rgba(255, 255, 255, 0.1);\n}\n\n.dark-mode .viewer-navbar,\n.dark-mode .chat-sidebar {\n  background-color: #1e1e1e;\n  border-color: #333;\n}\n\n.dark-mode .message.assistant {\n  background-color: #2d2d2d;\n  color: #f5f5f5;\n  border-color: #444;\n}\n\n.dark-mode .site-header.scrolled::before {\n  background: rgba(0, 0, 0, 0.95);\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n/* Home Screen */\n.home-screen {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.filters {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filters select,\n.filters input {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n  background-color: #fff;\n}\n\n.filters button {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.filters button:hover {\n  background-color: #0056b3;\n}\n\n.paper-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.paper-item {\n  padding: 15px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.paper-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Updated viewer layout */\n.viewer-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.viewer-navbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: #f8f9fa;\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.viewer-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.pdf-viewer {\n  flex: 1;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n/* Updated Chat Sidebar */\n.chat-sidebar {\n  width: 300px;\n  height: 100%;\n  background-color: #f8f9fa;\n  border-left: 1px solid #ddd;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-messages {\n  flex: 1;\n  padding: 10px;\n  overflow-y: auto;\n}\n\n.message {\n  margin-bottom: 10px;\n  padding: 10px;\n  border-radius: 5px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n}\n\n.message.user {\n  background-color: #007bff;\n  color: #fff;\n  border-color: #007bff;\n  align-self: flex-end;\n}\n\n.message.assistant {\n  background-color: #f1f1f1;\n  color: #333;\n  border-color: #ddd;\n  align-self: flex-start;\n}\n\n.chat-sidebar form {\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n  border-top: 1px solid #ddd;\n}\n\n.chat-sidebar input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.chat-sidebar button {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.chat-sidebar button:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .filters {\n    flex-direction: column;\n  }\n\n  .viewer-container {\n    flex-direction: column;\n  }\n\n  .chat-sidebar {\n    width: 100%;\n    height: 300px;\n    border-left: none;\n    border-top: 1px solid #ddd;\n  }\n}\n\n/* Paper note styles */\n.paper-note-blue {\n  display: inline-block;\n  background-color: blue;\n  color: white;\n  padding: 2px 4px;\n  border-radius: 3px;\n  margin-right: 5px;\n  font-size: 14px;\n}\n\n.paper-note-green {\n  display: inline-block;\n  background-color: green;\n  color: white;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 14px;\n}\n\n/* Remove default bottom margin from react-pdf pages to eliminate blank space between each PDF page */\n.react-pdf__Page {\n  margin-bottom: 0 !important;\n}\n\n/* Additional fix: force the canvas element rendered by react-pdf to display as block to remove extra whitespace */\n.react-pdf__Page canvas {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
